import {tabsAnatomy} from '@chakra-ui/anatomy';

export const anatomy = [...tabsAnatomy.keys, `badge`] as const;
export type Part = (typeof anatomy)[number];
